const app = {
  state: {
    isPC: true,
    columns: [],
    websiteInfo: {}
  },

  mutations: {
    SET_IS_PC: (state, isPC) => {
      state.isPC = isPC
    },
    SET_COLUMNS: (state, columns) => {
      state.columns = columns
    },
    SET_WEBSITE_INFO: (state, websiteInfo) => {
      state.websiteInfo = websiteInfo
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js